import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { DiaryFormElement } from "../../../../core/models/trial-diary-form/diary-form-element.model";

@Directive()
export abstract class ElementBase {
  @Output() elementMoveUp = new EventEmitter<DiaryFormElement>();
  @Output() elementMoveDown = new EventEmitter<DiaryFormElement>();
  @Output() elementManage = new EventEmitter<DiaryFormElement>();
  @Output() elementRemove = new EventEmitter<DiaryFormElement>();
  @Output() messageRemove = new EventEmitter<number>();
  @Output() messageEdit = new EventEmitter<number>();
  @Output() messageAdd = new EventEmitter<DiaryFormElement>();
  @Output() visibilityEdit = new EventEmitter<DiaryFormElement>();

  @Input() element: DiaryFormElement;
  @Input() index: number = 0;
  @Input() hasEntries: boolean = false;
  @Input() allElements: DiaryFormElement[] = [];
}
